var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-lines"},[_vm._t("default"),(_vm.hasData)?_c('ApexChart',{attrs:{"type":_vm.type,"options":_vm.options,"series":_vm.datasets}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }